import { render, staticRenderFns } from "./ViewDesignContent.vue?vue&type=template&id=b0a24f0a"
import script from "./ViewDesignContent.vue?vue&type=script&lang=js"
export * from "./ViewDesignContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports